import apiFetch from '../../apiFetch'

export default function (paperworkId, vehicleId, token) {
  return apiFetch({ endPoint: `dossier/paperwork/Notify?paperworkId=${paperworkId}&vehicleId=${vehicleId}`, method: 'PUT', token: token })
}
